import React from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import DatasourceBaseTextFields from "../Datasources/DatasourceBaseTextFields.jsx";

const DatasourceResalePartnersLIVE = (props) => {

    const Fields = [
        {Identifier:"ClientId", Translation:Translate("Client ID"), Required:true},
        {Identifier:"ApiKey", Translation:Translate("API key"), Required:true},
        {Identifier:"InstanceUrl", Translation:Translate("Domain"), Required:true}
    ]
    
    return (<DatasourceBaseTextFields SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} Fields={Fields} OnSetReady={props.OnSetReady}/>)

}

DatasourceResalePartnersLIVE.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceResalePartnersLIVE